export class GlobalTestConfig {
    public static readonly URL_WS: string = "ws://ubuntuvm.local:8080/test";
    public static readonly URL_WSS: string = "wss://ubuntuvm.local:8081/test";
    
    // Use this as signaling URL if the actual protocols don't matter
    public static readonly URL_SIGNALING: string = GlobalTestConfig.URL_WS;
    //use this for shared mode signaling
    public static readonly URL_SHARED: string = "ws://ubuntuvm.local:8080/testshared";
    public static readonly URL_BAD = 'ws://localhost:13776';
}